'use strict';

module.exports = require('./src/standalone/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/autocomplete.js/index.js
 ** module id = 1067
 ** module chunks = 0
 **/